import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { GetString } from '../../StringResourceManager';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { FirmwareInfo } from '../../../Interfaces/Devices/FirmwareInfo';
import { Button } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    firmwareDialog: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    firmwareDialogTitle: {
      minWidth: '650px',
      fontSize: '24px',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    firmwareDialogButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: 10,
    },
    firmwareClosePromptButtonLeft: {
      height: '40px',
      fontSize: '20px',
      width: '150px',
      marginRight: 10,
    },
    firmwareClosePromptButtonRight: {
      height: '40px',
      fontSize: '20px',
      width: '150px',
      marginLeft: 10,
    },
  })
);

interface ConfirmDeleteFirmwareDialogProps {
  onConfirm: (firmwareInfo?: FirmwareInfo) => any;
  onCancel: (event: any) => any;
  fileName?: string;
}

export const ConfirmDeleteFirmwareDialog = (
  props: ConfirmDeleteFirmwareDialogProps
) => {
  const classes = useStyles();

  const YES = GetString('YES');
  const NO = GetString('NO');
  const COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE = GetString(
    'COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE'
  );
  const COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE_QUESTION = GetString(
    'COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE_QUESTION'
  );
  const COLUMN_TITLE_FIRMWARE_FILE = GetString('COLUMN_TITLE_FIRMWARE_FILE');

  return (
    <Dialog
      onClose={props.onCancel}
      title={COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE}
    >
      <Typography variant="body1">
        {COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE_QUESTION}
      </Typography>
      <div>
        <section style={{ float: 'left' }}>
          <p>
            <strong>{COLUMN_TITLE_FIRMWARE_FILE}:</strong> {props.fileName}
          </p>
        </section>
      </div>
      <DialogActionsBar layout="center">
        <Button
          color="primary"
          variant="contained"
          onClick={() => props.onConfirm()}
        >
          {YES}
        </Button>
        <Button color="primary" variant="contained" onClick={props.onCancel}>
          {NO}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};
